'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { OrderedSet, OrderedMap } from 'immutable';
import SearchStatusPropType from 'SalesContentIndexUI/propTypes/SearchStatusPropType';
import SearchContentTypePropType from 'SalesContentIndexUI/propTypes/SearchContentTypePropType';
import SearchStatus from 'SalesContentIndexUI/data/constants/SearchStatus';
import SearchSortRecord from 'SalesContentIndexUI/data/records/SearchSortRecord';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Table } from 'foundations-components/transitional/components/Table';
import { View } from 'foundations-components/components/View';
import IndexTableColumns from './IndexTableColumns';
import IndexTableHeader from './IndexTableHeader';
import { assertPropsDefined } from '../utils/PropValidationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class IndexTable extends Component {
  constructor(...args) {
    super(...args);
    this.validateProps = () => {
      const {
        SuccessMarker,
        tableColumns,
        searchResults,
        selectionData,
        tableRow,
        searchStatus,
        setSort,
        setSelectedFolder,
        toggleFolderSelection,
        toggleRowSelection,
        isModal
      } = this.props;
      assertPropsDefined({
        SuccessMarker,
        tableColumns,
        searchResults,
        selectionData,
        tableRow,
        searchStatus,
        setSort,
        setSelectedFolder,
        toggleFolderSelection,
        toggleRowSelection,
        isModal
      });
    };
    this.renderSuccessMarker = () => {
      const {
        SuccessMarker,
        searchResults,
        searchStatus
      } = this.props;
      if (searchStatus === SearchStatus.LOADING || searchResults.isEmpty()) {
        return null;
      }
      return /*#__PURE__*/_jsx(SuccessMarker, {});
    };
    this.renderBody = () => {
      const {
        tableColumns,
        searchStatus,
        searchResults,
        tableRow,
        folderRow,
        selectionData,
        setSelectedFolder,
        folderContentType,
        toggleFolderSelection,
        toggleRowSelection,
        isModal
      } = this.props;
      const TableRow = tableRow;
      const FolderRow = folderRow;
      if (searchStatus === SearchStatus.LOADING) {
        const colSpan = isModal ? tableColumns.size : tableColumns.size + 1;
        return /*#__PURE__*/_jsx("tr", {
          children: /*#__PURE__*/_jsx("td", {
            colSpan: colSpan,
            children: /*#__PURE__*/_jsx(TFlex, {
              align: "center",
              children: /*#__PURE__*/_jsx(LoadingSpinner, {
                grow: true,
                minHeight: 200
              })
            })
          })
        });
      }
      const firstSearchResult = searchResults.first();
      return searchResults.map(searchResult => {
        const {
          contentType,
          id
        } = searchResult;
        const sharedProps = {
          searchResult,
          selectionData,
          tableColumns,
          isFirst: searchResult.equals(firstSearchResult),
          setSelectedFolder
        };
        const key = `index.row.${id}`;
        if (folderContentType === contentType && FolderRow) {
          return /*#__PURE__*/_createElement(FolderRow, Object.assign({}, sharedProps, {
            key: key,
            toggleFolderSelection: toggleFolderSelection
          }));
        }
        return /*#__PURE__*/_createElement(TableRow, Object.assign({}, sharedProps, {
          key: key,
          toggleRowSelection: toggleRowSelection
        }));
      }).toList();
    };
  }
  render() {
    const {
      currentSort,
      folderContentType,
      setSort,
      tableColumns,
      searchResults,
      selectionData,
      renderFolderTableActionButtons,
      renderSearchResultTableActionButtons,
      toggleRowSelection,
      isModal
    } = this.props;
    this.validateProps();
    return /*#__PURE__*/_jsxs(Table, {
      "data-test-id": "sales-content-table",
      children: [this.renderSuccessMarker(), /*#__PURE__*/_jsx(IndexTableColumns, {
        tableColumns: tableColumns,
        isModal: isModal
      }), /*#__PURE__*/_jsx(IndexTableHeader, {
        currentSort: currentSort,
        setSort: setSort,
        tableColumns: tableColumns,
        selectionData: selectionData,
        renderFolderTableActionButtons: renderFolderTableActionButtons,
        renderSearchResultTableActionButtons: renderSearchResultTableActionButtons,
        toggleRowSelection: toggleRowSelection,
        folderContentType: folderContentType,
        searchResults: searchResults,
        isModal: isModal
      }), /*#__PURE__*/_jsx(View, {
        as: "tbody",
        borderBlockEndWidth: isModal ? '100' : '0',
        borderBlockEndStyle: isModal ? 'solid' : 'none',
        borderBlockEndColor: isModal ? 'border-core-subtle' : 'do-not-use-transparent',
        children: this.renderBody()
      })]
    });
  }
}
IndexTable.propTypes = {
  SuccessMarker: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  currentSort: PropTypes.instanceOf(SearchSortRecord),
  tableColumns: PropTypes.instanceOf(OrderedSet).isRequired,
  searchResults: PropTypes.instanceOf(OrderedMap).isRequired,
  selectionData: PropTypes.object.isRequired,
  tableRow: PropTypes.any.isRequired,
  folderRow: PropTypes.any,
  searchStatus: SearchStatusPropType.isRequired,
  folderContentType: SearchContentTypePropType,
  renderFolderTableActionButtons: PropTypes.func,
  renderSearchResultTableActionButtons: PropTypes.func,
  setSort: PropTypes.func.isRequired,
  setSelectedFolder: PropTypes.func.isRequired,
  /** toggleFolderSelection: (searchResult: SearchResultRecordType) => void */
  toggleFolderSelection: PropTypes.func.isRequired,
  /** toggleRowSelection: (searchResult: SearchResultRecordType) => void */
  toggleRowSelection: PropTypes.func.isRequired,
  isModal: PropTypes.bool.isRequired
};